// @flow
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Loading from 'shared/components/Loading';
import { FormContext } from 'shared/formContext/FormContext';
import { fetchSageCompany } from 'shared/requests/postApiFetchSageCompany';

export const SageAuthorizationConfirmation = () => {
  const [initialized, setInitialized] = useState(false);
  const { push } = useHistory();
  const { search } = useLocation();

  const formContext = useContext(FormContext);

  const fetchSageCompanyInformation = useCallback(async (code, redirectUri) => {
    try {
      const response = await fetchSageCompany(code, redirectUri);
      formContext.setFields({
        businessStructure: 'limited-company',
        companyName: response.company_name,
        uniqueCompanyIdentifier: response.company_house_id,
        companyCodasId: response.company_codas_id,
        first_name: response.first_name,
        email: response.email
      });
      push('/loan-amount-and-term');
    } catch (error) {
      push('/loan-amount-and-term');
    }
  });
  useEffect(() => {
    if (!initialized) {
      setInitialized(true);

      const params = new URLSearchParams(search);
      const code = params.get('code') || '';
      const redirectUri = `${window.location.origin}/uk/borrower/eligibility/sage-authorization-confirmation`;

      // if the code is empty, we post to the api to handle the error
      fetchSageCompanyInformation(code, redirectUri);
    }
  }, [initialized, fetchSageCompanyInformation, search]);

  return (
    <>
      <Loading />;
    </>
  );
};
